import { render, staticRenderFns } from "./categories_component.vue?vue&type=template&id=25b18d93&scoped=true&"
import script from "../../assets/customer/js/categories.js?vue&type=script&lang=js&"
export * from "../../assets/customer/js/categories.js?vue&type=script&lang=js&"
import style0 from "./categories_component.vue?vue&type=style&index=0&id=25b18d93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b18d93",
  null
  
)

export default component.exports